import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_MANAGE_AUTORENEW_SCHEMA = Object.freeze({
  CURRENT_PLAN_UUID: '',
  PURCHASE_WINDOW: '',
  PROMO_CODE: '',
  AUTO_RENEW_ENABLED: false,
});
const RECORD = generateSchema(TRACKING_MANAGE_AUTORENEW_SCHEMA);
const KEYS: any = generateKeys(TRACKING_MANAGE_AUTORENEW_SCHEMA);

export class ManageAutorenewTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.manage_autorenew;
  }

  get properties() {
    return this.toJS();
  }
}
